export default "__VITE_ASSET__DROoCibp__"